<template>
	<div class="att-box field-box">
		<div class="att-box__item">
			<div class="att-box__item__title">
				<span>问题题目</span>
			</div>
			<el-input v-model="formSelect.questionName"  type="textarea" :rows="2" placeholder="请输入问题题目" size="small"></el-input>
		</div>
		<div class="att-box__item">
			<div class="att-box__item__title">
				<span>问题类型</span>
			</div>
			<el-select v-model="formSelect.questionType" placeholder="请选择" size="small" style="width: 100%">
				<el-option v-for="(_item, _index) in [
					{label: '单选题', value: '1'},
					{label: '多选题', value: '2'},
					{label: '简答题', value: '3'},
					{label: '判断题', value: '4'},
					{label: '下拉选择题', value: '6'},
				]" :key="_index" :label="_item.label" :value="_item.value"></el-option>
			</el-select>
		</div>
		<div class="att-box__item">
			<div class="att-box__item__title">
				<span>是否必答</span>
			</div>
			<el-select v-model="formSelect.isRequired" placeholder="请选择" size="small" style="width: 100%">
				<el-option v-for="(_item, _index) in [
					{label: '是', value: '1'},
					{label: '否', value: '0'},
				]" :key="_index" :label="_item.label" :value="_item.value"></el-option>
			</el-select>
		</div>
		<div class="att-box__item">
			<div class="att-box__item__title">
				<span>注意事项</span>
			</div>
			<el-input v-model="formSelect.tipsText" type="textarea" :rows="2" placeholder="请输入注意事项" size="small"></el-input>
		</div>
		<div class="att-box__item">
			<div class="att-box__item__title">
				<span>备注</span>
			</div>
			<el-input v-model="formSelect.remark" type="textarea" :rows="2" placeholder="请输入备注" size="small"></el-input>
		</div>
		<slot name="custom" />
		<div class="att-box__item" v-if="['DwRadio', 'DwCheckbox', 'DwSelect'].includes(formSelect.component)">
			<div class="att-box__item__title">
				<span>选项设置</span>
			</div>
			<div class="att-box__item__context">
				<draggable :list="formSelect.itemList" handle=".drag__move" v-if="['DwRadio', 'DwCheckbox'].includes(formSelect.component)">
					<div class="option-item" v-for="(item, index) in formSelect.itemList" :key="index">
						<svg-icon class="drag__move" icon-class="drag" style="cursor: move;margin-right: 8px;color: #409EFF" />
						<el-input :class="{error_input: repeat_list.includes(item.itemCode)}" v-model="item.itemCode" @input="handelRepeat" placeholder="选项值" size="mini" style="width: 80px;"></el-input>
						<el-divider direction="vertical"></el-divider>
						<el-input v-model="item.itemName" placeholder="选项名" size="mini" style="width: 80px"></el-input>
						<el-divider direction="vertical"></el-divider>
						<el-button @click.stop="handleOptionType(item, index)" type="text">{{(show_type_obj[item.showType])}}</el-button>
						<el-divider direction="vertical"></el-divider>
						<i @click.stop="handleOptionDelete(index)" class="el-icon-delete" style="cursor: pointer;color:red;float:right;margin-top: 8px"></i>
					</div>
				</draggable>
				<draggable :list="formSelect.itemList" handle=".drag__move" v-if="['DwSelect'].includes(formSelect.component)">
					<div class="option-item" v-for="(item, index) in formSelect.itemList" :key="index">
						<svg-icon class="drag__move" icon-class="drag" style="cursor: move;margin-right: 8px;color: #409EFF" />
						<el-input :class="{error_input: repeat_list.includes(item.itemCode)}" v-model="item.itemCode" @input="handelRepeat" placeholder="选项值" size="mini" style="width: 80px;"></el-input>
						<el-divider direction="vertical"></el-divider>
						<el-input v-model="item.itemName" placeholder="选项名" size="mini" style="width: 150px"></el-input>
						<el-divider direction="vertical"></el-divider>
						<i @click.stop="handleOptionDelete(index)" class="el-icon-delete" style="cursor: pointer;color:red;float:right;margin-top: 8px"></i>
					</div>
				</draggable>
				<el-button @click.stop="handleOptionAdd" size="small" class="el-icon-setting" style="width: 100%;border: dashed 1px #ccd4e0;"> 新增选项</el-button>
			</div>
		</div>
		<div class="att-box__item">
			<div class="att-box__item__title">
				<span>跳转规则</span>
			</div>
			<div class="att-box__item__context">
				<el-button @click.stop="handleRuleOption" size="small" class="el-icon-setting" style="width: 100%;border: dashed 1px #ccd4e0;"> 配置跳转规则</el-button>
			</div>
		</div>
		<el-dialog
			width="285px"
			:visible.sync="dialog_visible_option"
			:modal-append-to-body="false"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:z-index="999999" center>
			<template #title>
				<div class="header-dialog">
					<span class="title">显示方式</span>
				</div>
			</template>
			<section class="show-type">
				<el-select v-model="show_type_option_obj.showType" @change="show_type_option_obj.defaultValue = ''" placeholder="请选择" size="small" style="width: 245px;">
					<el-option v-for="_item in [
						{label: '标签', value: 1},
						{label: '文本框', value: 2},
						{label: '日期', value: 3},
						{label: '日期时间', value: 4},
					]" :key="_item.value" :label="_item.label" :value="_item.value"></el-option>
				</el-select>
			</section>
			<section class="show-type">
				<el-input v-model="show_type_option_obj.defaultValue" v-if="[1, 2].includes(show_type_option_obj.showType)" :disabled="show_type_option_obj.showType == 1" placeholder="默认值" size="small"></el-input>
				<el-date-picker v-model="show_type_option_obj.defaultValue" v-if="[3].includes(show_type_option_obj.showType)" value-format="yyyy-MM-dd" type="date" placeholder="默认值" size="small" style="width: 245px"></el-date-picker>
				<el-date-picker v-model="show_type_option_obj.defaultValue" v-if="[4].includes(show_type_option_obj.showType)" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="默认值" size="small" style="width: 245px"></el-date-picker>
			</section>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" type="primary" @click="dialog_visible_option = false">保 存</el-button>
			</span>
		</el-dialog>

		<el-dialog
			:visible.sync="dialog_visible_jump_configure"
			width="800px"
			:modal-append-to-body="false"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			:z-index="999999" center>
			<template #title>
				<div class="header-dialog">
					<span class="title">配置跳转规则</span>
					<el-button @click.stop="handleJumpConfigureAdd" size="mini" type="primary" plain>添加逻辑设置</el-button>
				</div>
			</template>
			<section class="option-dialog">
				<template v-if="formSelect.ruleList.length != 0">
					<div class="option-dialog-item" v-for="(item, index) in formSelect.ruleList" :key="index">
						<div class="option-dialog-item-rule">
							<div class="cell" v-for="(cell, c_index) in item.ruleCode.list" :key="c_index">
								<div>
									<span v-show="c_index === 0">跳转条件</span>
									<el-select v-show="c_index !== 0" v-model="item.ruleCode.and_or" :disabled="c_index > 1" size="mini" style="width: 72px">
										<el-option v-for="(_item, _index) in [{id: '&&', name: '且'}, {id: '||', name: '或'}]" :key="_index" :value="_item.id" :label="_item.name"></el-option>
									</el-select>
									<el-select v-model="cell.sourceCode" @change="(ev) => {return handleSourceCode(ev, cell)}" placeholder="请选择题目" size="mini">
										<el-option v-for="(_item, _index) in formData.formDesign" :key="_index" :value="_item.questionCode" :label="_item.questionName"></el-option>
									</el-select>
									<el-select v-if="cell.questionType != 3" v-model="cell.condition" size="mini">
										<el-option v-for="(_item, _index) in [
											{id: '==', name: '选中'},
											{id: '!=', name: '未选中'},
											{id: '>', name: '大于'},
											{id: '>=', name: '大于等于'},
											{id: '<', name: '小于'},
											{id: '<=', name: '小于等于'},
										]" :key="_index" :value="_item.id" :label="_item.name"></el-option>
									</el-select>
									<el-select v-if="cell.questionType != 3" v-model="cell.option" placeholder="请选择选项" size="mini">
										<el-option v-for="(_item, _index) in cell.option_list" :key="_index" :value="_item.itemCode" :label="_item.itemName"></el-option>
									</el-select>
									<!-- <el-input v-if="cell.questionType == 3" v-model="cell.option" placeholder="请输入" size="mini" style="width: 172px"></el-input> -->
									<i v-if="cell.questionType != 3 && c_index === 0" @click.stop="handleRuleOptionAdd(item.ruleCode.list)" class="el-icon-circle-plus-outline" style="color: #409EFF;cursor: pointer;margin-top: 8px;"></i>
									<i @click.stop="handleRuleOptionDelete(item.ruleCode.list, c_index)" v-if="c_index > 0" class="el-icon-remove-outline" style="color: #F56C6C;cursor: pointer;margin-top: 8px"></i>
								</div>
							</div>
						</div>
						<div class="option-dialog-item-jump">
							<span>跳转到</span>
							<el-select v-model="item.toCode" placeholder="请选择" size="mini">
								<el-option v-for="(_item, _index) in formData.formDesign" :key="_index" :value="_item.questionCode" :label="_item.questionName"></el-option>
								<el-option :key="-1" value="end" label="结束"></el-option>
							</el-select>
							<el-input v-model="item.remark" placeholder="请输入规则说明" size="mini" style="width: 172px"></el-input>
						</div>
						<div @click.stop="handleRuleDelete(index)" class="option-dialog-item-delete el-icon-remove"></div>
					</div>
				</template>
				<el-empty v-else description="您还未设置与该题相关的逻辑"></el-empty>
			</section>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="dialog_visible_jump_configure = false;">关 闭</el-button>
				<el-button size="mini" type="primary" @click="dialog_visible_jump_configure = false">保 存</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "CommonField",
	props: {
		formData: {
			type: Object,
		},
		formSelect: {
			type: Object,
		},
	},
	watch: {
		formSelect: {
			handler() {
				this.$emit('onChangeFormData', this.formData);
			},
			deep: true
		}
	},
	data() {
		return {
			show_type_obj: {
				1: '标签',
				2: '文本框',
				3: '日期',
				4: '日期时间'
			},
			dialog_visible_option: false,
			show_type_option_index: '',
			show_type_option_obj: {
				showType: '',
				defaultValue: ''
			},
			option_list: [],
			repeat_list: [],
			dialog_visible_jump_configure: false
		}
	},
	methods: {
		handleRuleOption() {
			for(const item of this.formSelect?.ruleList) {
				if(this.isString(item.ruleCode)) {
					this.$set(item, 'ruleCode', JSON.parse(item.ruleCode));
				}
			}
			this.dialog_visible_jump_configure = true;
		},
		isString(str){
			if(Object.prototype.toString.call(str) === "[object String]"){
				return true;
			}else{
				return false;
			}
		},
		handleRuleOptionAdd(cell) {
			cell.push({
				sourceCode: '',
				condition: '==',
				option: '',
				option_list: [],
				questionType: ''
			});
		},
		handleRuleOptionDelete(cell, index) {
			cell.splice(index, 1);
		},
		handleRuleDelete(index) {
			this.formSelect.ruleList.splice(index, 1);
		},
		handleSourceCode(val, cell) {
			for(const item of this.formData.formDesign) {
				if(val == item.questionCode) {
					cell.option = '';
					cell.option_list = item.itemList;
					cell.questionType = item.questionType;
				}
			}
		},
		handleJumpConfigureAdd() {
			const key = Math.random().toString(36).substr(2,4);
			this.formSelect.ruleList.push({
				ruleCode: {
					list: [{
						sourceCode: '',
						condition: '==',
						option: '',
						option_list: [],
						questionType: ''
					}],
					and_or: '&&',
				},
				// list: [{
				// 	sourceCode: '',
				// 	condition: '==',
				// 	option: '',
				// 	option_list: [],
				// 	questionType: ''
				// }],
				// and_or: '&&',
				toCode: '',
				remark: ''
			});
		},
		handelRepeat(val) {
			this.option_list = [];
			this.repeat_list = [];
			this.getArrayModel(this.formSelect.itemList);
			if(this.option_list.includes('')) {
				this.$message.error('选项值不能为空');
				return;
			}
			let result = this.repeatFun(this.option_list);
			this.repeat_list = result;
			if(result.length > 0) {
				this.$message.error('选项值不可重复');
			}
		},
		handleOptionAdd() {
			this.option_list = [];
			this.repeat_list = [];
			this.getArrayModel(this.formSelect.itemList);
			if(this.option_list.includes('')) {
				this.$message.error('选项值不能为空');
				return;
			}
			let result = this.repeatFun(this.option_list);
			this.repeat_list = result;
			if(result.length > 0) {
				this.$message.error('选项值不可重复');
			} else {
				const key = Math.random().toString(36).substr(2,4);
				this.formSelect.itemList.push({
					itemCode: `o_${key}`,
					itemName: '新选项',
					showType: 1,
					defaultValue: ''
				});
			}
		},
		handleOptionDelete(index) {
			this.formSelect.itemList.splice(index, 1);
			this.formSelect.defaultValue = '';
		},
		handleOptionType(item, index) {
			this.dialog_visible_option = true;
			this.show_type_option_index = index;
			this.show_type_option_obj = item;
		},
		repeatFun(arr) {
			let tmp = [];
			arr.sort().sort(function (a, b) {
				if(a === b && tmp.indexOf(a) === -1){
					tmp.push(a);
				}
			});
			return tmp;
		},
		getArrayModel(data){ 
			if (data) {
				for(const item of data) {
					this.option_list.push(item.itemCode);
				}
			}
		},
	}
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
	border: none;
}
::v-deep .error_input input{
	color: red;
	border-color: red;
}
.show-type {
	width: 100%;
	height: 28px;
	margin-bottom: 8px;

	& > span {
		display: inline-block;
		width: 70px;
		text-align: right;
	}
}
.option-item {
	width: 100%;
	height: 35px;
	margin-bottom: 8px;
	line-height: 35px;
	vertical-align: top;

	& .el-input {
		vertical-align: top;
	}

	& .el-button {
		width: 50px;
		vertical-align: top;
		margin: 0;
		padding: 0;
		line-height: 35px;
		font-size: 12px;
	}
}
.header-dialog {
	height: 28px;

	& .title {
		line-height: 28px;
		font-size: 18px;
		color: #303133;
		float: left;
	}

	& .el-button {
		float: right;
	}
}
.option-dialog {
	max-height: 400px;
	overflow-x: hidden;
	overflow-y: auto;
	padding: 0 10px;
	& > .header {
		width: 100%;
		height: 35px;
		background: #DCDFE6;
		padding: 0 32px;

		& > span {
			display: inline-block;
			width: 160px;
			text-align: center;
			line-height: 35px;
			color: #909399;
		}
	}
}
.option-dialog-item {
	width: 100%;
	border-radius: 2px;
	padding: 10px;
	margin: 6px 0 12px;
	border: solid 1px #DCDFE6;
	border-radius: 4px;
	background: #f7f8fa;
	position: relative;

	& > .option-dialog-item-delete {
		width: 10px;
		height: 10px;
		position: absolute;
		top: -8px;
		right: -2px;
		font-size: 16px;
		color: #F56C6C;
		cursor: pointer;
	}

	& > .option-dialog-item-rule {
		padding: 12px;

		& > .cell {
			width: 100%;
			margin-bottom: 12px;
			line-height: 28px;

			& > div {
				margin-bottom: 4px;

				& > span {
					display: inline-block;
					vertical-align: top;
					width: 80px;
					text-align: right;
					padding: 0 8px;
					font-size: 12px;
					color: #484848;
				}

				& .el-select, & .el-input {
					vertical-align: top;
					margin-right: 8px;
				}
				&:last-child {
					margin: 0;
				}
			}
			&:last-child {
				margin: 0;
			}
		}
	}

	& > .option-dialog-item-jump {
		border-top: dashed 1px #eaeaea;
		padding: 12px 12px 0;
		line-height: 28px;
		& > span {
			display: inline-block;
			vertical-align: top;
			width: 80px;
			text-align: right;
			padding: 0 8px;
			font-size: 12px;
			color: #484848;
		}

		& .el-select, & .el-input {
			vertical-align: top;
			margin-right: 8px;
		}
	}
}
::v-deep .el-dialog__body {
	padding: 0 20px 10px;
}
.att-box {
	width: 100%;

	& .att-box__item {
		width: 100%;
		margin-bottom: 24px;
		vertical-align: top;

		&__title {
			margin: 0;
			margin-bottom: 8px;
			
			& > span {
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #182D5C;
				line-height: 14px;
				margin-right: 5px;
			}

			& i {
				font-size: 13px;
				color: #cacad3;
				cursor: pointer;
			}
		}

		&__context {
			& .el-input, & .el-input-number {
				margin-bottom: 8px;
			}
		}
	}

	::v-deep .el-form-item {
		margin-bottom: 24px;

		& > .el-form-item__label {
			padding: 0;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #182D5C;
			line-height: 14px;
			margin-bottom: 8px;
		}
	}
}
.field-box {
	padding: 20px;

	&__item {
		width: 100%;
		margin-bottom: 24px;
		vertical-align: top;

		&__title {
			margin: 0;
			margin-bottom: 8px;
			
			& > span {
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #182D5C;
				line-height: 14px;
				margin-right: 5px;
			}

			& i {
				font-size: 13px;
				color: #cacad3;
				cursor: pointer;
			}
		}
	}

	::v-deep .el-form-item {
		margin-bottom: 24px;

		& > .el-form-item__label {
			padding: 0;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #182D5C;
			line-height: 14px;
			margin-bottom: 8px;
		}
	}
}
</style>